export default __webpack_public_path__ + "static/9-6f5c3f35d56043eef852094a0f777791.jpg";